import angular from 'angular';

import { LoginComponent } from './login.component';

const login = angular.module('login', ['ui.router', 'commons', 'auth']);

login.component('login', LoginComponent);

export const LoginModule = login;